import { FC } from "react";
import { Button } from "antd";
import { NextArrowIcon } from "src/assets/Icons";
import { transformRecord } from "src/utility";
import type { CardDataType, DataMap } from "./constants";
import { useOrdersList } from "../../context/OrderListContext";
import { useTranslation } from "react-i18next";

const OrderCard: FC<{ cardData: CardDataType; dataMap: DataMap }> = ({ cardData, dataMap }) => {
  const { t } = useTranslation();
  const { icon, title, tag, data, id } = cardData;
  const { navToDetails } = useOrdersList();
  const handleClick = () => {
    navToDetails(id);
  };
  return (
    <article className="divide-border-subtle bg-background-default flex flex-col gap-2 divide-y p-2 rounded-md shadow-md">
      <header className="flex items-center justify-between p-4">
        <div className="flex items-center gap-2">
          <div>{icon}</div>
          <div>{title}</div>
        </div>
        <div>{tag}</div>
      </header>
      <section className="flex flex-wrap items-start justify-start gap-2 p-5">
        {transformRecord(data, dataMap).map(({ key, label, display }) => (
          <div key={key} className="flex w-full shrink-0 grow-0 flex-col sm:w-[calc((100%-0.5rem)/2)] md:w-[calc((100%-1rem)/3)]">
            <div className="text-font-subtle text-xs font-medium">{label}</div>
            <div className="text-[1.1rem] font-semibold">{display}</div>
          </div>
        ))}
      </section>
      <footer className="flex items-center justify-end p-3">
        <Button icon={<NextArrowIcon/>} onClick={handleClick} iconPlacement="end" className="bg-background-primary! border-none! text-white! p-5! sm:w-min! w-full!">
          {t("UserHistory.common.viewDetails")}
        </Button>
      </footer>
    </article>
  );
};

export default OrderCard;
